import handleError from './handleError';
const registerServiceWorker = (scriptUrl, options) => {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.register(scriptUrl, options).catch(err => {
      handleError(err);
      throw err;
    });
  }
  return Promise.resolve(undefined);
};
export default registerServiceWorker;